import { Component } from '@angular/core';
import { productResourcesMock } from '../resource-center-side-bar/resources.mock';
import { Observable } from 'rxjs';
import { Product, ProductScope } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';

@Component({
  selector: 'resource-center-content',
  templateUrl: './resource-center-content.component.html',
  styleUrl: './resource-center-content.component.scss',
  standalone: false,
})
export class ResourceCenterContentComponent {
  productResources = productResourcesMock;

  product$: Observable<Product | null> = this.currentProductService.getProduct([
    ProductScope.DETAILS,
    ProductScope.PRICE,
  ]);

  constructor(protected currentProductService: CurrentProductService) {}
}
